<div *ngIf="bannerFlag" class="bannerAnuncio backBlue2" fxLayoutAlign="center center">
    <div class="cw" fxLayoutAlign="center center">
        <span class="ft14 ft500 gray-9 centertext">{{bannerMensaje}}</span>
    </div>
</div>

<section class="sectionBanner" ngClass.lt-md="fh">

    <div fxLayout="row" fxLayout.lt-md="column" fxAlignContent="space-between" class="fh cw" fxLayoutGap="5%">
        <!-- Texto -->
        <div fxLayout="column" fxLayoutAlign="center" fxFlex="40%" fxFlex.lt-md="100%">
            <span class="gray-2 ft11 mgb05">POWERED BY</span>
            <img [src]="logoP21" class="w-40" alt="">
            <br>
            <h3 class="gray-1 mgb20"> Entrenamiento en línea para el sector industrial </h3>
            <h6 class="gray-2 mgb20">Conviértete en un especialista de tu ramo. </h6>
            <button class="blueButton w-50" ngClass.lt-md="w-100" routerLink="/buscar"> Comenzar ahora</button>
        </div>
        <!-- Imagen -->
        <div fxLayout="column" fxLayoutAlign="center" fxShow.lt-md="false">
            <img [src]="bannerPredyc" class="imgPredyc" alt="">
        </div>
    </div>
</section>


<!---------------------------------------- cursos detacados versión PC -->

<section fxLayoutAlign="center center" fxShow.lt-md="false" fxShow="true">
    <div class="cw">

        <!-- Titulo -->
        <div fxLayout="column" fxLayoutAlign="center center" class="mgb40">
            <h5 class="centertext">Cursos para ingenieros de la industria.</h5>
        </div>

        <!-- Grid -->
        <div fxLayout="row" fxLayoutGap="1.5rem" fxLayoutAlign="space-between">

            <!-- card -->
            <div class="cursoCard shadow40 cursorPointer" fxLayout="column"
                *ngFor="let item of cursosDestacados | slice:0:4;  let i=index" (mouseover)="mostrarInfo=i"
                (mouseout)="mostrarInfo=-1" routerLink="/curso/{{item.id}}">

                <!-- card info -->
                <div [ngStyle]="{ 'background-image': 'url(' + item.foto + ')'}" class="cardImage1"
                    [ngClass]=" {'cardImage2':mostrarInfo === i}">
                </div>
                <div class="pd08">
                    <p class="default-font-color ft500 ft11 mgb05" href="">{{item.titulo}}</p>
                    <p class="cardInfoText1 default-font-color ft10 mgb0"
                        [ngClass]=" {'cardInfoText2':mostrarInfo === i}" fxShow.lt-sm="false" fxShow="true">
                        {{item.resumen}}
                    </p>
                </div>
                <div class="pd08 cardAuthor " fxLayout="row" fxLayoutAlign="space-between center">
                    <div>
                        <img [src]=item.instructorFoto class="avatar2">
                        <a class="author default-font-color ft9" href="">{{item.instructorNombre}}</a>
                    </div>
                    <div>
                        <a class="dark-font-color ft500 ft11">${{item.precioFinal}} USD</a>
                    </div>
                </div>
            </div>
        </div>

        <!-- ver más -->
        <div fxLayout="row" fxLayoutAlign="center">
            <a class="blueLink mgt20" routerLink="/buscar">
                <div fxLayoutAlign=" center">
                    <span class="ft500 ft16 blueLink mgt0">Ver más cursos</span>
                    <mat-icon class="mgl05 linkIcon ft25"> arrow_forward </mat-icon>
                </div>
            </a>
        </div>

    </div>
</section>



<!---------------------------------------- cursos detacados versión mobile -->

<section class="section-mobile-auto-height" fxLayoutAlign="center center" fxShow.lt-md="true" fxShow="false">
    <div class="cw" fxLayout="column" fxLayoutAlign="space-between center" fxLayoutGap="3rem">


        <!-- titulo -->
        <div fxLayout="column" fxLayoutAlign="center center">
            <h5 class="centertext">Cursos para ingenieros de la industria.</h5>
        </div>

        <!-- grid -->
        <div fxShow="false" fxShow.lt-md="true">

            <!-- card -->
            <div *ngFor="let item of cursosDestacados | slice:0:4;  let i=index" class="mgb20">
                <div  routerLink="/curso/{{item.id}}"
                    fxLayoutGap="1rem" fxFlex="100%" fxLayout="column"
                    class="cursoCardMobile radius3 shadow40 cursorPointer " fxFlex=100%>

                    <!-- card info -->
                    <div [ngStyle]="{ 'background-image': 'url(' + item.foto + ')'}" class="cardImageMobile"> </div>
                    <h6 class="ft13 ft500 mgt0 mgb0 pdl08 pdr08">
                        {{item.titulo}} </h6>
                    <div class="pd08 cardAuthor " fxLayout="row" fxLayoutAlign="space-between center">
                        <div>
                            <img [src]=item.instructorFoto class="avatar2">
                            <a class="author default-font-color ft9" href="">{{item.instructorNombre}}</a>
                        </div>
                        <div>
                            <a class="dark-font-color ft500 ft11">${{item.precioFinal}} USD</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ver mas  -->
        <div fxLayout="row" fxLayoutAlign="center">
            <a class="blueLink mgt20" routerLink="/buscar">
                <div fxLayoutAlign=" center">
                    <span class="ft500 ft16 blueLink mgt0">Ver más cursos</span>
                    <mat-icon class="mgl05 linkIcon ft25"> arrow_forward </mat-icon>
                </div>
            </a>
        </div>

    </div>
</section>



<!----------------------------------------- Instructores destacados -->

<section class="section-100vh backLight" ngClass.lt-md="section-mobile-auto-height" fxLayoutAlign="center center">
    <div class="cw" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between center" fxLayoutGap="5rem"
        fxLayoutGap.lt-md="3rem">


        <!----------------------------------------- grid instructores visible en PC -->
        <div fxlayout="column" fxShow.lt-md="false" fxFlex="50%">
            <div *ngFor="let item of instructoresDestacados | slice:0:5;  let i=index ">
                <a href="" routerLink="/instructor/{{item.id}}">
                    <div class="mgt10 pd08 pdr10 shadow50 backWhite radius3" fxLayout="row"
                        fxLayoutAlign="space-between" fxLayoutGap="2rem">
                        <div fxLayout="row" fxLayoutGap="1rem" fxFlex="100%">
                            <img [src]=item.foto class="avatar4">
                            <div>
                                <h6 class="ft13 ft500 mgt0 mgb0">
                                    {{item.nombre}} </h6>
                                <p class="mgt0 mgb0 ft10">{{item.resumen}} </p>
                                <p class="mgt0 mgb0 ft10">
                                    <span *ngIf="item.cantCursos===1" class="ft10 gray-6">{{item.cantCursos}} curso</span>
                                    <span *ngIf="item.cantCursos>1" class="ft10 gray-6">{{item.cantCursos}} cursos</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>

        <!----------------------------------------- Texto visible -->
        <div fxLayout="column" fxLayoutAlign="space-between center" fxFlex="50%">
            <div class="" fxLayout="column" fxLayoutAlign="center">
                <h5 class="centertext">Descubre instructores de larga trayectoria y gran experiencia.</h5>
                <h6 class="ft16 centertext"> Obtén los conocimientos aplicables de la
                    mano con expertos. </h6>
                <div>
                    <a routerLink="buscar" class="blueLink mgt60">
                        <div fxLayoutAlign="center center">
                            <span class="ft500 ft16 blueLink mgt0">Conoce todos los instructores</span>
                            <mat-icon class="mgl05 linkIcon ft25"> arrow_forward </mat-icon>
                        </div>
                    </a>
                </div>
            </div>
        </div>

        <!----------------------------------------- texto visible en tlf  -->
        <div fxlayout="column" fxShow="false" fxShow.lt-md="true" class="fw">
            <div *ngFor="let item of instructoresDestacados | slice:0:5;  let i=index ">
                <a href="" routerLink="/instructor/{{item.id}}">
                    <div class="mgt10 pd08 pdr10 shadow50 backWhite radius3" fxLayout="row"
                        fxLayoutAlign="space-between" fxLayoutGap="2rem">
                        <div fxLayout="row" fxLayoutGap="1rem" fxFlex="100%">
                            <img [src]=item.foto class="avatar4">
                            <div>
                                <h6 class="ft13 ft500 mgt0 mgb0">
                                    {{item.nombre}} </h6>
                                <p class="mgt0 mgb0 ft10">{{item.resumen}} </p>
                                <p class="mgt0 mgb0 ft10">
                                    <span *ngIf="item.cantCursos===1" class="ft10 gray-6">{{item.cantCursos}} curso</span>
                                    <span *ngIf="item.cantCursos>1" class="ft10 gray-6">{{item.cantCursos}} cursos</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </div>

    </div>
</section>



<!------------------------------------------------------------------------------------------------ SESIONES    -->

<section class="section-100vh" ngClass.lt-md="section-mobile-auto-height" fxLayoutAlign="center center">
    <div class="cw" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between center" fxLayoutGap="5rem"
        fxLayoutGap.lt-md="3rem">

        <!-- sesiones -->
        <div fxLayout="column">

            <!-- titulo -->
            <div fxLayoutAlign.lt-md="center">
                <h5 fxFlex="100%" fxFlex.lt-md="100%" class="centertext">Cursos 100% grabados para completar al ritmo
                    deseado.
                </h5>
            </div>

            <!-- caja sesiones -->
            <div fxLayout="column" fxLayoutAlign="center" fxFlex="100%">

                <!-- titulo sesiones y barra progreso -->
                <div fxLayout="row" fxFlex="100%" class="mgt10 mgb10">
                    <h6 class="h6Title mgb0">Sesiones</h6>
                    <div fxLayout="column" fxFlex="100%" class="mgl30">
                        <br>
                        <span class="ft12 mgb05 gray-8">Progreso: 43%</span>
                        <mat-progress-bar mode="determinate" [value]="43"></mat-progress-bar>
                    </div>
                </div>

                <!-- tabla de sesiones -->
                <div class="pd05 pdr0 border-t" *ngFor="let item of sesion;  let i=index" fxLayoutAlign="space-between"
                    fxLayoutGap="1rem">
                    <div fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign="space-between" fxFlex="100%"
                        fxLayoutGap="1rem">
                        <div fxLayout="row" fxLayoutGap="1rem">
                            <div fxLayout="row" fxLayoutAlign="center center"  *ngIf="item.completado===1">
                                <mat-icon class="iconBorderBlue blue-3 ft16" *ngIf="item.tipo==='video'">play_arrow
                                </mat-icon>
                                <mat-icon class="iconBorderBlue blue-3 ft16" *ngIf="item.tipo==='lectura'">short_text
                                </mat-icon>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="center center"  *ngIf="item.completado===0">
                                <mat-icon class="iconBorder ft16" *ngIf="item.tipo==='video'">play_arrow
                                </mat-icon>
                                <mat-icon class="iconBorder ft16" *ngIf="item.tipo==='lectura'">short_text
                                </mat-icon>
                            </div>
                        </div>
                        <p class="mgb0 fw">
                            <span class="mgb0 mgr05 ft12 gray-6">{{item.num}}.</span>
                            <span class="">{{item.titulo}}</span>
                        </p>
                        <p class="mgb0 ft12 gray-6" fxFlex="10%" fxFlex.lt-md="15%"> {{item.duracion}} min</p>
                    </div>
                </div>

            </div>
        </div>

        <!-- foto laptop -->
        <div fxLayout="column" fxLayoutAlign="center" fxFlex="50%" class="fw">
            <img [src]="laptop" alt="" class="fw">
        </div>

    </div>
</section>



<!------------------------------------------------------------------------------------------------ Certificado -->

<section class="section-100vh backGray9" ngClass.lt-md="section-mobile-auto-height" fxLayoutAlign="center center">
    <div class="cw" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between center" fxLayoutGap="5rem">

        <!-- certificado gt-sm -->
        <div fxFlex="50%" fxShow.lt-md="false">
            <img [src]="certificado" alt="" class="w-100 shadow30">
        </div>

        <!-- Texto  -->
        <div fxFlex="50%" fxLayout="column" fxLayoutAlign="center" fxLayoutAlign.lt-md="center center">
            <h5 class="gray-1 mgb20 centertext">Valida los conocimientos adquiridos. </h5>
            <h6 class="gray-3 centertext">Obtén un certificado al completar tu curso.</h6>
            <h6 class="gray-5 ft16 centertext"> Comparte tu certificado en tus perfiles con un link único. </h6>
            <div fxLayout="row" fxLayoutAlign="center" class="mgt20">

                <span class="chip backBlue5 gray-2">https://predyc.com/X58hj563</span>

            </div>

        </div>

        <!-- certificado lt-md  -->
        <div fxFlex="50%" fxShow="false" fxShow.lt-md="true">
            <img [src]="certificado" alt="" class="w-100 shadow30">
        </div>

    </div>
</section>



<!----------------------------------------------------------------------------- Empieza ahora: Call to Action (CTA)  -->

<section class="seccionComienzaAhora" ngClass.lt-md="seccionComienzaAhora-mobile" fxLayoutAlign="center center">
    <div class="cw" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between center" fxLayoutGap="5rem">

        <div fxLayout="row" fxLayout.lt-md="column" class="fw" fxLayoutAlign="space-between">
            <div fxLayout="column" fxLayoutAlign="center" fxLayoutAlign.lt-md="center center" fxFlex="30%">
                <h5 class="gray-8 ft500" ngClass.lt-md="centertext">Empieza ahora</h5>
                <h6 class="mgt30" ngClass.lt-md="centertext">Alcanza el nivel de especialista.</h6>
                <h6 class="ft16" ngClass.lt-md="centertext">Adquiere los conocimientos requeridos.</h6>
                <button class="empiezaButton mgt30" routerLink="/buscar">
                    <span class="ft22 gray-1">Explorar cursos </span>
                </button>
            </div>
        </div>

        <img [src]="experta" alt="" class="imgExperta" fxShow.lt-md="false">
        <img [src]="experta" alt="" fxShow="false" fxShow.lt-md="true" class="fw">

    </div>
</section>



<!----------------------------------------------------------------------------- Capacitacion para empresas  -->

<section class="section-100vh backBlue5" ngClass.lt-md="section-mobile-auto-height" fxLayoutAlign="center center">
    <div class="cw" fxLayout="column" fxLayoutAlign="space-between center" fxLayoutGap="5rem">

        <!-- texto -->
        <h5 class="gray-1 centertext">Capacitación para empresas</h5>
        <div fxLayout="column" fxLayoutAlign="center center">
            <h6 class="gray-4 centertext">Inicia un plan de formación junto con tu equipo de trabajo </h6>
            <p class="gray-1 centertext"> Desarrolla el perfil profesional de cada miembro.</p>
            <a class="lightLink">
                <div fxLayoutAlign=" center">
                    <span class="ft500 ft13 lightLink" routerLink="/capacitacion-empresas">Conocer más</span>
                    <mat-icon class="mgl05 linkIcon">arrow_forward </mat-icon>
                </div>
            </a>
        </div>

        <!-- Imagen -->
        <div fxLayout="row" fxLayoutGap="2rem">
            <div fxLayout="column" fxLayoutAlign="center">
                <img [src]="capacitacionEmpresas" class="w-100" alt="">
            </div>
        </div>

    </div>
</section>